<template>
    <div>
        <h3>邀请用户管理</h3>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="邀请人ID">
                <el-input v-model="filter.inviterId" placeholder="职位id"></el-input>
            </el-form-item>
            <el-form-item label="被邀请人ID">
                <el-input v-model="filter.inviteesId" placeholder="职位名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="id" label="邀请ID"></el-table-column>
            <el-table-column prop="inviterName" label="邀请人昵称"></el-table-column>
            <el-table-column prop="inviter" label="邀请人ID"></el-table-column>
            <el-table-column prop="inviterRole" label="邀请人角色">
                <template slot-scope="scope">{{role[scope.row.inviterRole]}}</template>
            </el-table-column>
            <el-table-column prop="inviteesName" label="被邀请人昵称"></el-table-column>
            <el-table-column prop="invitees" label="被邀请人ID"></el-table-column>
            <el-table-column prop="inviteesRole" label="被邀请人角色">
                <template slot-scope="scope">{{role[scope.row.inviteesRole]}}</template>
            </el-table-column>
            <el-table-column prop="inviteesCreateTime" label="被邀请人注册时间"></el-table-column>
            <el-table-column prop="firstOrderTime" label="被邀请人成单时间"></el-table-column>
            <el-table-column prop="firstOrderId" label="首次结算单号"></el-table-column>
            <el-table-column label="操作" width="280">
                <template slot-scope="scope">
                    <el-button-group size="mini">
                        <el-button type="success" :disabled="scope.row.registReward === 1" size="mini" @click="updateInviteReward(scope.row, 'registReward')">注册奖励已发放</el-button>
                        <el-button type="success" size="mini" :disabled="scope.row.billReward === 1" @click="updateInviteReward(scope.row, 'billReward')">结算奖励已发放</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'

const {
    invite,
} = api

export default {
    name: 'job-list',
    data() {
        return {
            map,
            loading: true,
            list: [],
            total: 0,
            limit: 20,
            pageNum: 1,
            total: 0,
            filter: {
                inviterId: '',
                inviteesId: '',
            },
            // rewardIssued: 1 // 是否已发送奖励（1：没发放 2：注册奖励已发放 3：结算奖励已发放 4：全部奖励已发放）
            role: {
                1: '甲方',
                2: '乙方',
            }
        }
    },
    components: {},
    computed: {},
    watch: {
        pageNum() {
            this.fetch(2)
        },
    },
    methods: {
        async fetch(num) {

            if (num == 1) {
                this.pageNum = 1
            }

            let pageNum = this.pageNum
            let limit = this.limit
            this.loading = true

            let {
                inviterId,
                inviteesId,
            } = this.filter

            let obj = {
                pageNum: pageNum,
                limit: limit,
                inviterId,
                inviteesId,
            }

            let res = await invite.list(obj)

            this.list = res.data.data
            this.loading = false
            this.total = res.data.pageinfo.totalCount
        },
        async updateInviteReward(row, field) {
            if (confirm('是否确认奖励已经发放')) {
                let obj = {
                    id: row.id,
                }
                obj[field] = 1
                let {
                    data: {
                        code
                    }
                } = await invite.update(obj)
                if (code == 200) {
                    this.$message.success('奖励发放状态更新成功')
                    this.fetch()
                }
            }
        }
    },
    mounted() {
        this.fetch()
    },
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/invite/invites.vue